module.exports = __webpack_public_path__ + "static/media/team-off.0316ee0e.svg";